// extracted by mini-css-extract-plugin
export var cardLayout = "_2g-1";
export var paginationContainer = "_2g-0";